export const INTERNATIONAL_TITLE = 'יעדים במזרח';
export const RECOMMENDED_ARTICLES_TITLE = 'דברים שכדאי לדעת';
